import React from 'react';
import useVehiclePlaceOrder from './hooks/useVehiclePlaceOrder';
import VehiclePlaceOrderForm from './components/VehiclePlaceOrderForm';

const PlaceOrderPage = () => {
    const props = useVehiclePlaceOrder();
    return <VehiclePlaceOrderForm {...props} />;
};

export default PlaceOrderPage;
